import { produce } from 'immer';

export const createCcrcModal = (set) => ({
  ccrcGuidId: '',
  setCcrcGuidId: (newParams) =>
    set(
      produce(({ ccrcModal }) => {
        ccrcModal.ccrcGuidId = newParams;
      }),
    ),
  ccrcInputs: {},
  setInitCcrcInputs: (newParams) =>
    set(
      produce(({ ccrcModal }) => {
        ccrcModal.ccrcInputs = newParams;
      }),
    ),
  setCcrcInputs: ({ id, checked }) =>
    set(
      produce(({ ccrcModal }) => {
        ccrcModal.ccrcInputs = {
          ...ccrcModal.ccrcInputs,
          [id]: { ...ccrcModal.ccrcInputs[id], checked: checked },
        };
      }),
    ),
  setAllCcrcInputs: ({ checked }) =>
    set(
      produce(({ ccrcModal }) => {
        ccrcModal.ccrcInputs = Object.fromEntries(
          Object.keys(ccrcModal.ccrcInputs).map((k) => [k, { ...ccrcModal.ccrcInputs[k], checked }]),
        );
      }),
    ),
});
